"use client";
import { useLayoutEffect } from "react";

import { matchesUrl } from "@stadium/helpers/dom";

import { isDev } from "@constants/env-variables";

import { PRODUCT_VIEW_PATHNAME } from "@constants/routes";
import { OLD_PRODUCT_VIEW_PATHNAME } from "@constants/old-routes";

export function FetchInterceptor({
  storeUpdatedAt,
  configKey,
}: {
  storeUpdatedAt: number;
  configKey: number;
}) {
  const storeRscCacheDomain = process.env.NEXT_PUBLIC_STORE_RSC_CACHE_DOMAIN;
  const storeRscCacheUrl = storeRscCacheDomain ? `https://${storeRscCacheDomain}` : "";

  useLayoutEffect(() => {
    if (!storeRscCacheUrl || !storeUpdatedAt || isDev()) return;

    const originalFetch = window.fetch;

    window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
      const url = typeof input === "string" ? input : input.toString();

      if (url.includes("_rsc=")) {
        const newUrl = new URL(
          url.replace(window.location.origin, storeRscCacheUrl as string),
          window.location.origin,
        );
        const productKey =
          matchesUrl({ pathname: PRODUCT_VIEW_PATHNAME, url: newUrl.pathname }) ||
          matchesUrl({ pathname: OLD_PRODUCT_VIEW_PATHNAME, url: newUrl.pathname })
            ? // @ts-ignore - window.__p_key is a custom property
              window.__p_key || 0
            : 0;
        // @ts-ignore - window.__p_key is a custom property, reset key
        window.__p_key = 0;
        const buildId = process.env.NEXT_PUBLIC_BUILD_ID || "";
        const key = configKey + storeUpdatedAt + productKey;

        newUrl.searchParams.set("b", buildId);
        newUrl.searchParams.set("k", key);
        return originalFetch(newUrl.toString(), init);
      }

      return originalFetch(input, init);
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, [storeUpdatedAt, configKey, storeRscCacheUrl]);

  return null;
}
